// extracted by mini-css-extract-plugin
export var container = "_6k-0";
export var error = "_6k-9";
export var label = "_6k-5";
export var light = "_6k-6";
export var md = "_6k-3";
export var sm = "_6k-2";
export var thin = "_6k-8";
export var thinBold = "_6k-7";
export var vertical = "_6k-4";
export var xs = "_6k-1";